import styled, { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Source Sans Pro', sans-serif;
 } 
`;

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  /* text-align:center ;
  display: flex ;
  justify-content: center;
  align-items: center;
  flex-direction: column; */
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 50px;
  padding-left: 50px;

  @media screen and (max-width: 991px) {
    padding-right: 30px;
    padding-left: 30px;
  }
`;

interface ButtonStyleProps {
  primary?: boolean | number;
  big?: boolean;
  fontBig?: boolean;
  dark?: boolean | number;
}

export const Button = styled.button<ButtonStyleProps>`
  border-radius: 4px;
  background: ${({ primary }) => (primary ? "#22A39F" : "#222222")};
  padding: ${({ big }) => (big ? "12px 64px" : "10px 20px")};
  color: #fff;
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};
  outline: none;
  border: none;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    background: #fff;
    background-color: ${({ primary }) => (primary ? "#1b807c" : "#111111")};
    color: ${({ primary }) => (primary ? "#f1f1f1f1" : "#2222222")};
  }

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export default GlobalStyle;
